import { render, staticRenderFns } from "./Jumenterie.vue?vue&type=template&id=e0563052&"
import script from "./Jumenterie.vue?vue&type=script&lang=js&"
export * from "./Jumenterie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports